// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookFreeHotelAmendsLayout-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/BookFreeHotelAmendsLayout/BookFreeHotelAmendsLayout.mobile.scss
 ** module id = 947
 ** module chunks = 1
 **/